import React from "react";
import axios from "axios";

const deleteReward = (oid, id) => {
  axios.delete(`/admin/opportunities/${oid}/rewards/${id}`);
  return false;
};

const Reward = ({ opportunity_id, amount, status, id, onRemove }) => (
  <div className="message is-success">
    <div className="message-body">
      ${amount} paid when the referral is {status}
      <a
        className="delete is-pulled-right"
        onClick={() => {
          deleteReward(opportunity_id, id);
          onRemove();
        }}
      />
    </div>
  </div>
);

export default Reward;
